import { render, staticRenderFns } from "./CouponJoychat.vue?vue&type=template&id=002430e0&scoped=true"
import script from "./CouponJoychat.vue?vue&type=script&lang=js"
export * from "./CouponJoychat.vue?vue&type=script&lang=js"
import style0 from "./CouponJoychat.vue?vue&type=style&index=0&id=002430e0&lang=less&scoped=true"
import style1 from "./CouponJoychat.vue?vue&type=style&index=1&id=002430e0&lang=scss"
import style2 from "./CouponJoychat.vue?vue&type=style&index=2&id=002430e0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002430e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('002430e0')) {
      api.createRecord('002430e0', component.options)
    } else {
      api.reload('002430e0', component.options)
    }
    module.hot.accept("./CouponJoychat.vue?vue&type=template&id=002430e0&scoped=true", function () {
      api.rerender('002430e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CCoupon/CouponJoychat.vue"
export default component.exports